// SEO utility: set page meta + inject JSON-LD + OG tags
function setMeta(name: string, content: string, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (el) el.setAttribute("content", content);
  else {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    el.setAttribute("content", content);
    document.head.appendChild(el);
  }
}

export interface PageMetaOptions {
  ogImage?: string;
  ogType?: string;
}

export function setPageMeta(title: string, description: string, canonical?: string, options?: PageMetaOptions) {
  document.title = title;
  setMeta("description", description);
  // OG tags
  setMeta("og:title", title, "property");
  setMeta("og:description", description, "property");
  setMeta("og:type", options?.ogType || "website", "property");
  setMeta("og:site_name", SITE_NAME, "property");
  setMeta("og:locale", "fr_FR", "property");
  setMeta("og:image", options?.ogImage || `${SITE_URL}/pwa-icon-512.png`, "property");
  if (canonical) {
    setMeta("og:url", canonical, "property");
  }
  // Twitter
  setMeta("twitter:card", options?.ogImage ? "summary_large_image" : "summary");
  setMeta("twitter:title", title);
  setMeta("twitter:description", description);
  setMeta("twitter:image", options?.ogImage || `${SITE_URL}/pwa-icon-512.png`);
  // Default indexable robots (override with setNoIndex on private pages)
  setMeta("robots", "index, follow, max-image-preview:large, max-snippet:-1");
  // Canonical
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (canonical) {
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;
  }
}

export function setNoIndex() {
  setMeta("robots", "noindex, nofollow");
}

export function removeNoIndex() {
  document.querySelector('meta[name="robots"][content="noindex, nofollow"]')?.remove();
}

export function injectJsonLd(id: string, data: object) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.setAttribute("type", "application/ld+json");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd(id: string) {
  document.getElementById(id)?.remove();
}

export const SITE_URL = "https://sudweb-tech.com";
export const SITE_NAME = "SUDWEB-TECH";
export const PHONE = "06 69 26 04 92";
export const PHONE_INTL = "+33669260492";

export function breadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.name,
      "item": item.url,
    })),
  };
}
